import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    active: false,
};

const activateSlice = createSlice({
    name: 'activeIdent',
    initialState,
    reducers: {
        setActivateTrue: (state) => {
            state.active = true;
        },
        clearActiveIdent(state) {
            state.active = false;
        }
    }
});

export const { setActivateTrue, clearActiveIdent } = activateSlice.actions;
export default activateSlice.reducer;